import { openModal } from "action/modal/openModal";
import { ICompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";
import { ProductImage } from "api/interfaces/product-api.type";
import useScreenSize from "hoc/useScreenSize";
import Image from "next/legacy/image";
import { useDispatch } from "react-redux";
import HideIf from "util/HideIf";
import { getProductImage } from "util/helper/getProductImage";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import { getThumbImage } from "util/helper/getThumbImage";
import { getProductHeading } from "util/product/get-product-heading";
import styles from "./apparel-component.module.scss";
interface IProps {
  images: string[];
  title: string;
  manufacturerImage: string;
  productImagesV2: ProductImage[];
  product: ICompactProduct;
  videos: {
    title: string;
    youtubeId: string;
    thumbnailUrl: string;
  }[];
}

const ApparelImageSection = ({
  images, title, manufacturerImage, productImagesV2, product, videos = [],
}: IProps) => {
  const [isMobile, isTablet, isDesktop] = useScreenSize();
  const dispatch = useDispatch();

  let imagePreload = "";

  if (isMobile) {
    imagePreload = "m";
  } else if (isTablet) {
    imagePreload = "t";
  } else if (isDesktop) {
    imagePreload = "ds";
  }
  const [image1, image2, image3] = images;
  let updatedMedia = images.map((image) => (
    { type: "image", image }
  ));
  if (videos.length > 0) {
    updatedMedia = [...updatedMedia.slice(0, 3), { type: "video", videos }, ...updatedMedia.slice(3)];
  }

  const gridView = images.length > 1;

  function videoIndex() {
    return updatedMedia.findIndex((media) => media.type === "video");
  }

  function handleImageClick(selectedImage: number, isImageClick = true) {
    let updatedIndexOfImage = selectedImage;
    const videoIdx = videoIndex();
    if (videoIdx !== -1 && selectedImage > videoIdx) {
      updatedIndexOfImage -= 1;
    }

    dispatch(openModal("thumbnailVideo", {
      productImagesV2,
      getThumbImagePath: getThumbImage,
      imageTitle: getProductHeading(product),
      product,
      productLineVideos: [...videos],
      isImageClick,
      defaultSelectedImage: updatedIndexOfImage,
      isMerchProduct: true,
      isMobile,
    }));
  }

  function ImageThumbnail({
    key, src, idx, isImageClick,
  }: {
    key: string; src: string; idx: number; isImageClick?: boolean;
  }) {
    return (
      <Image
        key={key}
        src={src}
        alt={title}
        width={480}
        height={600}
        className={styles.apparel_image}
        onClick={() => handleImageClick(idx, isImageClick)}
        // layout="fill"
      />
    );
  }

  return (
    <div
      className={styles.apparel_images_container}
    >
      <div className={styles.apparel_manufacturer}>
        <Image
          src={getRelativeImagePath(manufacturerImage)}
          width={155}
          height={42}
          alt="Parts Avatar Logo"
        />
      </div>
      <HideIf show={!gridView}>
        <div
          className="m-b-10"
        >
          <Image
            src={getProductImage(image1, false, imagePreload)}
            alt={title}
            width={0}
            height={0}
            sizes="100vw"
            className={styles.apparel_image_no_grid}
            onClick={() => handleImageClick(0)}
          />
        </div>
      </HideIf>

      <HideIf show={image2 && !gridView}>
        <div className={styles.apparel_second_row}>
          {[image2, image3].filter(Boolean).map((image, idx) => (
            <Image
              key={image}
              src={getProductImage(image, false, imagePreload)}
              alt={title}
              width={0}
              height={0}
              sizes="100vw"
              className={styles.apparel_image_no_grid}
              onClick={() => handleImageClick(idx + 1)}
            />
          ))}
        </div>
      </HideIf>
      <HideIf show={gridView}>
        <div className={styles.apparel_grid_images}>
          {updatedMedia.filter(Boolean).map((image, idx) => {
            let src = getProductImage(image.image, false, imagePreload);
            if (image.type === "video") {
              src = image.videos[0].thumbnailUrl ? getRelativeImagePath(`/cms/${image.videos[0].thumbnailUrl}`) : `https://i.ytimg.com/vi/${image.videos[0].youtubeId}/sddefault.jpg`;
              return (
                <div className={styles.video_thumbnail} key={`${image.type}-${idx}-container`}>
                  <ImageThumbnail key={image.image} src={src} idx={idx} isImageClick={false} />
                  <i className={`fa fa-play ${styles.play_button}`} onClick={() => handleImageClick(idx + 1, false)} />
                </div>
              );
            }
            return (
              <ImageThumbnail key={`${image.type}-${idx}`} src={src} idx={idx} />
            );
          })}
        </div>
      </HideIf>
    </div>
  );
};

export default ApparelImageSection;
